module.exports = __webpack_public_path__ + "img/uploaddemo-3-a.ba0d4996.png";